
function Footer() {
  function handleSubscribe() {
    alert("Thanks for subscribing!!!");
  }

  return (
    <>
      <footer style={{height:'120px', }}>
        <div className="container" >
          <div className="footer-content">
            <ul className="footer-content__2">
              <li>Contact Us</li>


              <li style={{ fontSize: "14px", fontWeight: "bold" }}>
                <a href="tel:+1 242-373-2277">&#x260E; +1 242-373-2277</a>
              </li>

              
              <li style={{ fontSize: "14px", fontWeight: "bold" }}>
                <a href="tel:+1 242-439-1303">&#x260E; +1 242-439-1303</a>
              </li>

              <li style={{ fontSize: "14px", fontWeight: "bold" }}>
                <a
                  href="mailto: 
                carrentals.bullseye@gmail.com"
                >
                  &#9993; carrentals.bullseye@gmail.com
                </a>
              </li>

              <li>
                <a
                  style={{ fontSize: "14px", fontWeight: "bold" }}
                  target="_blank"
                  rel="noreferrer"
                 // href="https://maps.app.goo.gl/gyo3oLjVkVEJomSi8"
                  // href="https://jephunneh.com/"
                >
                  &#128205; Tract # 2 Britannia Blvd & Sunset Highway , Freeport, Grand Bahama
                </a>
              </li>


            </ul>

            <ul className="footer-content__1">
              <li>
                <span style={{ color: "#B8860B" }}>Bulls Eye Car Rental</span>
               
              </li>

              <li style={{ fontSize: "13px" }}>
                We're the best choice if you are looking to rent a car in Freeport Grand Bahama. We offer a range of vehicles for car rental with great customer support.
              
              </li>

              <li>
                <a
                  style={{ fontSize: "14px" }}
                  target="_blank"
                  rel="noreferrer"
                  href="https://dev2code.com"
                >
                  <span>Website By:</span>
                </a>
              </li>

              <li>
                <a
                  style={{ fontSize: "14px" }}
                  target="_blank"
                  rel="noreferrer"
                  href="https://web4business.tech"
                >
                  <span style={{ color: "#B8860B" }}>Qasim</span>
                </a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Company</li>
              <li>
                {/*<a   href="https://maps.app.goo.gl/gyo3oLjVkVEJomSi8"> 
                  Our Location
                </a> */}
              </li>
              <li>
               <a
  href="/policies"
  style={{ textDecoration: "underline", fontWeight: "600" }}
>
  Policies
</a>
              </li>
              

{/* 
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://adminsleekrentals.netlify.app/"
                  //
                >
                  Admin &#128187;
                </a>
              </li> */}

            </ul>

            <ul className="footer-content__2">
              <li>Working Hours</li>
              <li>Mon - Sun: 9:00AM - 5:00PM</li>
              <li>Christmas: Closed</li>
              <li>Easter: Closed</li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
